import { Component } from '../types';

import BaseMapper from './base';

class FallbackComponent extends BaseMapper {
  public async generateComponent(): Promise<Component> {
    const childrens: Component[] = [
      ...(await this.renderChildrenFromId()),
      ...(await this.renderChildren()),
    ];

    return {
      name: 'FallbackComponent',
      props: {
        name: this.toPascalCase(this.page.template),
      },
      childrens,
    };
  }
}

export default FallbackComponent;
